import React, { useEffect, useState } from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { BACKEND_URL } from '../../services/Helper';
import './MallsPage.css';

const MallsPage = () => {
  const navigate = useNavigate();
  const outletCtx = useOutletContext() || {};
  const userLocation = outletCtx.location || null;

  const [malls, setMalls] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMalls = async () => {
      try {
        const params = userLocation
          ? `?lat=${userLocation.lat}&lng=${userLocation.lon}`
          : '';
        const res = await fetch(`${BACKEND_URL}/nearbe/getallmalls${params}`);
        const data = await res.json();
        setMalls(data.malls || []);
      } catch {
        setMalls([]);
      } finally {
        setLoading(false);
      }
    };
    fetchMalls();
  }, [userLocation]);

  return (
    <div className="malls-page">
      <div className="malls-hero">
        <h1 className="malls-title">🏬 Malls</h1>
        <p className="malls-sub">Explore malls near you — shops, offers and more</p>
      </div>

      {loading ? (
        <div className="malls-loading">
          <div className="malls-spinner" />
          <p>Loading malls...</p>
        </div>
      ) : malls.length === 0 ? (
        <div className="malls-empty">
          <span className="malls-empty-icon">🏬</span>
          <p>No malls listed yet. Check back soon!</p>
        </div>
      ) : (
        <div className="malls-grid">
          {malls.map((mall) => (
            <div
              key={mall._id}
              className="mall-card"
              onClick={() => navigate(`/userdashboard/malls/${mall._id}`)}
            >
              <div className="mall-card-img-wrap">
                {mall.mallImage ? (
                  <img src={mall.mallImage} alt={mall.mallName} className="mall-card-img" />
                ) : (
                  <div className="mall-card-img-placeholder">🏬</div>
                )}
              </div>
              <div className="mall-card-body">
                <h3 className="mall-card-name">{mall.mallName}</h3>
                <p className="mall-card-city">📍 {mall.mallCity}</p>
                {mall.description && (
                  <p className="mall-card-desc">{mall.description}</p>
                )}
                <div className="mall-card-chips">
                  <span className="mall-chip mall-chip-shops">🏪 {mall.shopCount} Shops</span>
                  <span className="mall-chip mall-chip-offers">🏷️ {mall.offerCount} Offers</span>
                  {mall.distanceKm !== null && mall.distanceKm !== undefined && (
                    <span className="mall-chip mall-chip-dist">📍 {mall.distanceKm} km away</span>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MallsPage;
